import React from 'react'
import Card from './Card'

const Process = () => {
  return (
    <>
      <div className="relative w-full py-28 px-8 bg-white">
        <div className="text-center mb-10 space-y-4">
          <p className="font-extrabold text-3xl sm:text-4xl text-black">
            GST is complex, but <span className="text-[#519980]">EasyGST</span>{" "}
            made it easier
          </p>
          <h3 className="text-lg sm:text-2xl">
            EasyGST is very well crafted with a User-friendly Interface
          </h3>
        </div>
        <div className="sm:block flex flex-col justify-center items-center">
          <Card />
        </div>
      </div>
    </>
  );
}

export default Process